import { lazy } from 'react'

const ChatBotViewAsync = lazy(() => {
    return import(/* webpackChunkName: "ChatBot" */ './ChatBot')
})

export default ChatBotViewAsync
